import { render } from "./detailAddressItem.vue?vue&type=template&id=80d1434a"
import script from "./detailAddressItem.vue?vue&type=script&lang=js"
export * from "./detailAddressItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gegeheusel/Sites/leica-partnersuche-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__